import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import PinVerify from "../../components/common/PinVerify";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footerAccessibilityPageFooter";
import "../../styles/Main.css";
import { Image } from "react-bootstrap";
import LoginImage from "../../assets/images/on-removebg-preview.svg";

const TwoFactorVerification = () => {
  document.title = "Authentication";

  const navigate = useNavigate();
  const { user } = useSelector((state) => ({
    user: state.Login.user,
  }));

  const email = user.email;
  const handleComplete = () => {
    navigate("/employers/jobpostdashbord");
  };

  console.log("inside the twofactor", user);
  return (
    <>
      <Container fluid className="p-0 signup-bg d-flex flex-column min-vh-100">
        <Navbar />
        <div className="flex-grow-1 d-flex justify-content-center align-items-center container p-0">
          <Row className="w-100 reverse-col d-flex justify-content-between align-items-center">
            <Col md={6} lg={5}>
              <Card className="signup-card text-dark">
                <h4>
                  <strong>Two Factor Verification</strong>
                </h4>
                <p class="mt-2">
                  <strong>Enter 6-digit code*</strong>
                </p>
                <PinVerify
                  className="border border-info"
                  emailorMobileNumber={email}
                  type="twoFa"
                  userType="Employer"
                  onComplete={handleComplete}
                />
              </Card>
            </Col>

            <Col md={6} lg={5} className="d-none d-md-block">
              <Image className="login-img" src={LoginImage} fluid />
            </Col>
          </Row>
        </div>
        <Footer className="mt-auto" />
      </Container>
    </>
  );
};
export default TwoFactorVerification;
